import { UserExtraLite } from "@frontend/common";

  export class LikesSummary {
    
    allLikersCount:number;
    othersLikersCount:number;
    randomSubsetLikersCount:number;
    randomSubsetLikers:UserExtraLite[]

}